import React from "react";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { Routes } from "../../../../root/routes";
import { useHistory } from "react-router";
import { EmployeePageWrapper } from "./EmployeePageWrapper";
import { AccessRequestInstructionsVendorsTable } from "../../../requestInstructions/AccessRequestInstructionsPage";

export function EmployeeDataAccessPage() {
  const history = useHistory();

  const orgId = usePrimaryOrganizationId();
  return (
    <EmployeePageWrapper
      selectedTabKey="employee-data-access"
      nextOnClick={() => history.push(Routes.hrCenter.hrDataMap.employeeExceptions)}
      nextDisabled={false}
    >
      <div className="tw-boundary">
        <div className="mb-[40px] max-w-[800px]">
          <p>
            Your business will be required to retrieve or delete an employee's and/or applicant's
            personal data from your records when they make an Access or Deletion Request. On this
            screen, you'll identify the locations where your business keeps HR data.
          </p>
        </div>

        <AccessRequestInstructionsVendorsTable
          orgId={orgId}
          vendorsCollectionContexts={["EMPLOYEE"]}
        />
      </div>
    </EmployeePageWrapper>
  );
}
